import { UrlRuntimeParams } from './UrlRuntimeParams';

export * from './interfaces';

export default UrlRuntimeParams;
